module.exports = __webpack_public_path__ + "static/media/Image4.d95050f0.png";